module.exports = __webpack_public_path__ + "static/media/dog-shower-min.9bcfc554.jpg";